export const CREATE_MEETING_GROUP = `
  mutation CreateMeetingGroup($input: CreateMeetingGroupInput!) {
    createMeetingGroup(input: $input) {
      id
      tenant_id
      meeting_id
      group_id
      group {
        id
        name
        monthly_date
      }
      meeting {
        id
        month
        current_date
        type
      }
    }
  }
`;

export const CREATE_MEETING_GROUPS = `
  mutation CreateMeetingGroups($input: CreateMeetingGroupsInput!) {
    createMeetingGroups(input: $input) {
      id
      tenant_id
      meeting_id
      group_id
      group {
        id
        name
        monthly_date
      }
      meeting {
        id
        month
        current_date
        type
      }
    }
  }
`;

export const REMOVE_MEETING_GROUP = `
  mutation RemoveMeetingGroup($meeting_id: Int!, $group_id: Int!, $tenant_id: Int!) {
    removeMeetingGroup(meeting_id: $meeting_id, group_id: $group_id, tenant_id: $tenant_id)
  }
`;

export const COMPLETE_MEETING_GROUPS = `
  mutation CompleteMeetingGroups($meeting_id: Int!, $group_ids: [Int!]!) {
    completeMeetingGroups(meeting_id: $meeting_id, group_ids: $group_ids) {
      id
      group_id
      approval_status
      attendance_loaded
    }
  }
`;

export const MARK_ATTENDANCE_LOADED = `
  mutation MarkAttendanceLoaded($meeting_id: Int!, $group_ids: [Int!]!) {
    markAttendanceLoaded(meeting_id: $meeting_id, group_ids: $group_ids) {
      id
      group_id
      approval_status
      attendance_loaded
    }
  }
`;
